import { IComponentNode } from 'app/app/editor/index.functions';
import { alpha, Box } from '@mui/material';
import { useAppBuilderContext } from 'app/app/editor/context';

export default function NodeNameLine({ node }: { node: IComponentNode }) {
    const ctx = useAppBuilderContext();

    const componentName = node.type == 'container' ? 'container' : ctx.page.components[node.params.uid].component;
    let tmp = node?.params?.attr?.title ? [node?.params.attr.title] : componentName.split('.').reverse();

    if (node.subtype == 'page_menu') {
        tmp = ['menu container'];
    }

    return (
        <Box
            onClick={() => ctx.editComponent({ uid: node.params?.uid })}
            sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, py: '2px' }}
        >
            <Box
                sx={{
                    lineHeight: '13px',
                    color: 'primary.main',
                }}
            >
                <Box
                    component={'span'}
                    sx={{
                        color: node.type == 'container' ? 'primary.main' : 'error.main',
                    }}
                >
                    {node.params?.uid === 'page' ? node.params?.uid : tmp[0]}
                </Box>
                {tmp[1] ? (
                    <Box
                        component={'span'}
                        sx={{
                            color: (theme) => alpha(theme.palette.text.primary, 0.4),
                        }}
                    >
                        {' '}
                        (library: {tmp[1]})
                    </Box>
                ) : null}
            </Box>
        </Box>
    );
}
